<!--
 * @Description: 规章制度 阅读
 * @Author: PF
 * @Date: 2024-04-19 14:56:18
 * @LastEditors: PF
 * @LastEditTime: 2024-04-29 15:09:18
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-card shadow="never" class="hp100">
        <template #header>
          <div class="card-header">
            <h2>{{ruleForm.bt}}</h2>
            <h4 class="fu-biao-ti">
              <span v-if="ruleForm.scrmc">上传人：{{ruleForm.scrmc}}</span>
              <span v-if="ruleForm.scsj">上传时间：{{ruleForm.scsj}}</span>
            </h4>
          </div>
        </template>
        <div class="nei-rong">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.nr"></p>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail', 'ReturnData'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/sys/guizhangzhidu/guizhangzhiduyuedu/' + props.row.id,
        ruleForm
      })
      emits('ReturnData')
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-card__header) {
  text-align: center;
}
:deep(.el-card__body) {
  height: calc(100% - 70px);
    overflow: auto;
}
.fu-biao-ti {
  color: #73767a;
  margin-top: 10px;
  span {
    margin: 0 10px;
  }
}
.nei-rong {
  color: #73767a;
  line-height: 30px;
}
</style>
